import { css, useTheme } from '@fable/theme'
import { useTypedSelector } from '../../hooks'
import {
  Grid,
  PaginationContainer,
  PaginationContainerContext,
} from '@fable/components'
import { BookListItem } from '@fable/types'
import { getBookListsWithAction } from './helpers'
import { UserBookList } from './UserBookList'
import { useContext } from 'react'

interface Props {
  isAuthUser?: boolean
}

const UserBookListsContent: React.VFC<Props> = ({ isAuthUser = false }) => {
  const { list } = useContext(PaginationContainerContext)
  const { profile } = useTypedSelector(({ user }) => user)
  const { user } = useTypedSelector(({ social }) => social)
  const { mediaQueries } = useTheme()
  const canViewAll = isAuthUser || profile.data?.id === user?.data?.id

  // filter if not viewer is not the logged in user
  const filteredList: BookListItem[] = (list || []).filter((x: BookListItem) =>
    canViewAll ? x : x.privacy === 'everyone'
  )

  const bookList: BookListItem[] = getBookListsWithAction(
    filteredList,
    isAuthUser
  )

  const createGridCols = () => {
    if (bookList.length <= 4) return bookList.length
    return 4 % bookList.length
  }

  const styles = {
    itemContainer: css`
      grid-gap: 20px;
      grid-template-columns: repeat(1, 154px);
      ${mediaQueries.mobileXS} {
        grid-template-columns: repeat(2, 154px);
      }
      ${mediaQueries.mobileL} {
        grid-template-columns: repeat(
          ${createGridCols()},
          minmax(115px, 154px)
        );
      }
      ${mediaQueries.tablet} {
        grid-template-columns: repeat(${createGridCols()}, 156px);
      }
      ${mediaQueries.desktop} {
        grid-template-columns: repeat(${createGridCols()}, 200px);
        grid-gap: 20px 32px;
      }
    `,
  }

  return (
    <Grid className={styles.itemContainer}>
      {bookList.map((item, i: number) => (
        <UserBookList
          key={i}
          index={i}
          item={item}
          isAddNewAction={isAuthUser && i === 0}
        />
      ))}
    </Grid>
  )
}

const UserBookLists = ({ isAuthUser = false }: Props) => {
  const { profile } = useTypedSelector(({ user }) => user)
  const { user } = useTypedSelector(({ social }) => social)
  const uuid = isAuthUser ? profile.data?.id : user?.data?.id

  if (!uuid) return null

  return (
    <PaginationContainer
      scrollLevel="fullPage"
      queryArgs={['bookLists', uuid]}
      endpoint={`/v2/users/${uuid}/book_lists`}
      limit={20}
    >
      <UserBookListsContent />
    </PaginationContainer>
  )
}

export default UserBookLists
